import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { QuestionnaireGroup } from '@mona/models';
import * as QuestionnaireGroupsActions from '../state/actions/questionnaire-groups.actions';
import * as QuestionnaireGroupsSelectors from '../state/selectors/questionnaire-groups.selectors';

/**
 * Configurable Questionnaires facade service
 */
@Injectable({
    providedIn: 'root',
})
export class ConfigurableQuestionnairesFacade {
    /** All questionnaire groups */
    questionnaireGroups$: Observable<QuestionnaireGroup[]> = this.store.select(
        QuestionnaireGroupsSelectors.selectQuestionnaireGroups,
    );

    /** Visible questionnaire groups only */
    visibleQuestionnaireGroups$: Observable<QuestionnaireGroup[]> = this.store.select(
        QuestionnaireGroupsSelectors.selectVisibleQuestionnaireGroups,
    );

    /** Is loading */
    isLoading$: Observable<boolean> = this.store.select(
        QuestionnaireGroupsSelectors.selectQuestionnaireGroupsIsLoading,
    );

    /** Error */
    error$: Observable<unknown | null> = this.store.select(QuestionnaireGroupsSelectors.selectQuestionnaireGroupsError);

    /**
     * Constructor
     * @param store Store
     */
    constructor(private store: Store) {}

    /**
     * Load questionnaire groups
     */
    loadQuestionnaireGroups(): void {
        this.store.dispatch(QuestionnaireGroupsActions.loadQuestionnaireGroups());
    }

    /**
     * Clear questionnaire groups
     */
    clearQuestionnaireGroups(): void {
        this.store.dispatch(QuestionnaireGroupsActions.clearQuestionnaireGroups());
    }
}
